import { render, staticRenderFns } from "./StaffPerformanceForm.vue?vue&type=template&id=1d54e658&"
import script from "./StaffPerformanceForm.vue?vue&type=script&lang=js&"
export * from "./StaffPerformanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports